/* =====================================================================
   Au Delà des Fleurs — pages boutique « Le Sourire » (collections + fiches produit)
   · « Livrable aujourd'hui » seulement si c'est vrai (heure de Paris, heures limites du thème)
   · Fiche produit : tailles, prix, croquis, livraison offerte, galerie, zoom, barre d'achat mobile
   · Collection : tri, texte d'intro repliable
   · « Vous aimerez aussi » chargé en différé
   ===================================================================== */
(function () {
  'use strict';

  var DAYS = ['', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
  /* Défilement doux, sauf si l'appareil demande moins d'animations */
  function SMOOTH() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }

  function parisNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', hour12: false }).formatToParts(new Date());
    var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
    return { day: { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[get('weekday')], hour: parseInt(get('hour'), 10) % 24 };
  }

  /* ---------- Livraison du jour ----------
     Calendrier commun : window.adfCal (snippets/adf-hours.liquid) — fermetures exceptionnelles, délai en ligne de Zapiet.
     · « aujourd'hui » = livraison le jour même SUR APPEL (avant l'heure limite d'un jour de livraison) ;
     · [jour]  = premier jour proposé EN LIGNE (comme le calendrier Zapiet : 24 h de préparation) ;
     · [appel] = prochain jour livrable en appelant ; [h] = son heure limite.
     Les cartes produit (icône téléphone, « sur appel ») suivent le jour SUR APPEL. */
  function ship(scope) {
    var cal = window.adfCal;
    (scope || document).querySelectorAll('[data-adf-cutoffs]').forEach(function (root) {
      try {
        var today, phone = null, online = null;
        if (cal) {
          today = cal.sameDay(); phone = cal.phoneDay(); online = cal.onlineDay();
        } else {
          var c = root.getAttribute('data-adf-cutoffs').split(',').map(function (n) { return parseInt(n, 10) || 0; });
          var cut = { 1: c[0], 2: c[1], 3: c[2], 4: c[3], 5: c[4], 6: c[5], 7: c[6] };
          var now = parisNow();
          today = cut[now.day] > 0 && now.hour < cut[now.day];
          for (var d = 1; d <= 7 && !phone; d++) {
            var nd = ((now.day - 1 + d) % 7) + 1;
            if (cut[nd] > 0) phone = { label: d === 1 ? 'demain' : DAYS[nd], cut: cut[nd] + 'h' };
          }
          online = phone;
        }
        if (today && phone) root.querySelectorAll('[data-adf-cut-h]').forEach(function (el) { el.textContent = phone.cut; });
        root.querySelectorAll('[data-adf-when]').forEach(function (el) {
          el.hidden = (el.getAttribute('data-adf-when') === 'today') !== today;
        });
        if (today || !phone) return;
        var fill = function (tpl) {
          return tpl.replace('[jour]', (online || phone).label).replace('[appel]', phone.label).replace('[h]', phone.cut);
        };
        root.querySelectorAll('[data-adf-later]').forEach(function (el) {
          if (!el.dataset.adfTpl) el.dataset.adfTpl = el.textContent;
          el.textContent = fill(el.dataset.adfTpl);
        });
        var later = root.getAttribute('data-adf-later');
        if (later) {
          root.querySelectorAll('[data-adf-ship-label]').forEach(function (s) { s.textContent = later.replace('[jour]', phone.label).replace('[appel]', phone.label); });
          root.querySelectorAll('[data-adf-ship]').forEach(function (s) { s.classList.add('is-later'); });
        }
      } catch (e) {}
    });
  }

  function money(cents) {
    var v = cents / 100;
    return (cents % 100 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
  }

  /* ---------- Fiche produit ---------- */
  if (!customElements.get('adf-product')) {
    customElements.define('adf-product', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var json = this.querySelector('[data-adf-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.freeFrom = parseInt(this.dataset.freeFrom, 10) || 0;
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.idInput = this.form && this.form.querySelector('[name=id]');
        this.submit = this.querySelector('[data-adf-atc]');
        this.options = Array.prototype.slice.call(this.querySelectorAll('[data-adf-option]'));
        this.options.forEach((fs) => fs.addEventListener('change', () => this.onOptionChange()));
        this.syncSketch();
        this.initSketchTap();
        this.initGallery();
        this.initZoom();
        this.initBar();
        this.initTomb();
        this.initPay();
      }

      /* v14-7 : entretien de tombe — « En une fois » ou « À chaque passage » (abonnement Shopify Subscriptions).
         La correspondance formule → (variante abonnement, selling_plan, prix) vient du JSON [data-adf-sub-map]. */
      initPay() {
        var fs = this.payFs = this.querySelector('[data-adf-pay]');
        if (!fs) return;
        var mapEl = fs.querySelector('[data-adf-sub-map]');
        try { this.subMap = JSON.parse(mapEl.textContent) || []; } catch (e) { this.subMap = []; }
        this.subVariant = fs.getAttribute('data-sub-variant');
        var self = this;
        var once = fs.querySelector('input[value="once"]'), sub = fs.querySelector('input[value="sub"]');
        this.payUpdate = function () {
          var vid = String(self.idInput ? self.idInput.value : '');
          var m = null;
          for (var i = 0; i < self.subMap.length; i++) if (String(self.subMap[i].variant) === vid) m = self.subMap[i];
          self.payMatch = m;
          var v = null;
          for (var j = 0; j < self.variants.length; j++) if (String(self.variants[j].id) === vid) v = self.variants[j];
          if (!m) { fs.hidden = true; once.checked = true; }
          else {
            fs.hidden = false;
            fs.querySelector('[data-adf-pay-once]').textContent = v ? money(v.price) : '';
            fs.querySelector('[data-adf-pay-sub]').textContent = money(m.price) + ' ' + m.label;
          }
          var isSub = !!(m && sub.checked);
          var amount = isSub ? money(m.price) : (v ? money(v.price) : null);
          if (amount) {
            self.querySelectorAll('[data-adf-price-amount]').forEach(function (el) { el.textContent = amount; });
            self.querySelectorAll('[data-adf-atc-price]').forEach(function (el) { el.textContent = isSub ? amount + ' / passage' : amount; });
          }
        };
        fs.addEventListener('change', this.payUpdate);
        this.options.forEach(function (o) { o.addEventListener('change', function () { setTimeout(self.payUpdate, 0); }); });
        this.payUpdate();
      }

      // À l'envoi : si « à chaque passage », on envoie la variante abonnement + selling_plan (puis on remet tout en place)
      applyPay() {
        var fs = this.payFs;
        if (!fs || fs.hidden || !this.payMatch) return;
        var sub = fs.querySelector('input[value="sub"]');
        if (!sub || !sub.checked) return;
        var orig = this.idInput.value;
        this.idInput.value = this.subVariant;
        var sp = this.form.querySelector('input[name="selling_plan"]');
        if (!sp) { sp = document.createElement('input'); sp.type = 'hidden'; sp.name = 'selling_plan'; this.form.appendChild(sp); }
        sp.disabled = false; sp.value = this.payMatch.plan;
        var idIn = this.idInput;
        setTimeout(function () { idIn.value = orig; sp.disabled = true; }, 0);
      }

      /* v14-7 : entretien de tombe — date minimale, date lisible dans la commande, champs obligatoires
         (le formulaire du thème est en novalidate : on contrôle ici, avant l'envoi au panier) */
      initTomb() {
        var box = this.tomb = this.querySelector('[data-adf-tomb]');
        if (!box) return;
        var date = box.querySelector('[data-adf-tomb-date]');
        var out = box.querySelector('[data-adf-tomb-date-out]');
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        if (date) {
          var d = new Date();
          d.setDate(d.getDate() + (parseInt(box.getAttribute('data-min-days'), 10) || 2));
          date.min = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
          var sync = function () {
            if (!out) return;
            if (!date.value) { out.value = ''; return; }
            try {
              var s = new Date(date.value + 'T12:00:00').toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
              out.value = s.charAt(0).toUpperCase() + s.slice(1);
            } catch (e) { out.value = date.value; }
          };
          date.addEventListener('change', sync);
          date.addEventListener('input', sync);
          sync();
        }
        var err = box.querySelector('[data-adf-tomb-error]');
        box.querySelectorAll('[required], [data-adf-tomb-if-cem], [data-adf-tomb-cem]').forEach(function (f) {
          var clear = function () {
            if (f.checkValidity()) f.removeAttribute('aria-invalid');
            if (err && !box.querySelector('[aria-invalid="true"]')) err.hidden = true;
          };
          f.addEventListener('input', clear);
          f.addEventListener('change', clear);
        });
        // Avant product-form.js : écoute en phase de capture sur le parent du formulaire
        var pf = this.querySelector('product-form');
        if (pf) pf.addEventListener('submit', (e) => {
          if (!this.tombValid()) { e.preventDefault(); e.stopPropagation(); return; }
          this.applyPay();
          // champs laissés vides : pas de ligne « Cimetière : » vide dans la commande (désactivés le temps de l'envoi)
          var off = [];
          box.querySelectorAll('[name^="properties["]').forEach(function (f) {
            if (!String(f.value || '').trim() && !f.disabled) { f.disabled = true; off.push(f); }
          });
          setTimeout(function () { off.forEach(function (f) { f.disabled = false; }); }, 0);
        }, true);
      }

      tombValid() {
        var box = this.tomb;
        if (!box) return true;
        var bad = [];
        // mode « livraison » (chrysanthèmes…) : le nom sur la tombe n'est demandé que si un cimetière est choisi
        var cem = box.querySelector('[data-adf-tomb-cem]');
        var withCem = !!(cem && cem.value);
        box.querySelectorAll('[required], [data-adf-tomb-if-cem]').forEach(function (f) {
          if (!f.required && !withCem) { f.removeAttribute('aria-invalid'); return; }
          var ok = f.checkValidity() && String(f.value || '').trim() !== '';
          if (ok) f.removeAttribute('aria-invalid'); else { f.setAttribute('aria-invalid', 'true'); bad.push(f); }
        });
        var err = box.querySelector('[data-adf-tomb-error]');
        if (!bad.length) { if (err) err.hidden = true; return true; }
        if (err) {
          var names = bad.map(function (f) {
            var n = f.getAttribute('data-adf-tomb-label') || '';
            if (f.type === 'date' && f.value && f.validity.rangeUnderflow) n = 'une date de passage plus tardive';
            if (f.type === 'tel' && f.value && f.validity.patternMismatch) n = 'un numéro de portable complet';
            return n;
          });
          err.textContent = 'Pour que nous trouvions la tombe, il manque : ' + names.join(', ') + '.';
          err.hidden = false;
        }
        bad[0].scrollIntoView({ behavior: SMOOTH(), block: 'center' });
        setTimeout(function () { try { bad[0].focus({ preventScroll: true }); } catch (e) {} }, 450);
        return false;
      }

      /* 2026-11-04 : toucher un bouquet du croquis choisit sa taille (3 bouquets, un par tiers du dessin) */
      initSketchTap() {
        var svg = this.querySelector('[data-adf-sketch] .adf-sz__svg');
        var first = this.options[0];
        if (!svg || !first) return;
        svg.addEventListener('click', function (e) {
          var r = svg.getBoundingClientRect();
          var i = Math.min(2, Math.max(0, Math.floor((e.clientX - r.left) / r.width * 3)));
          var input = first.querySelector('input[data-index="' + i + '"]');
          if (!input || input.checked) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      selected() {
        return this.options.map(function (fs) { var i = fs.querySelector('input:checked'); return i ? i.value : null; });
      }

      syncSketch() {
        var first = this.options[0];
        var sketch = this.querySelector('[data-adf-sketch]');
        if (!first || !sketch) return;
        var on = first.querySelector('input:checked');
        var idx = on ? on.getAttribute('data-index') : '0';
        sketch.querySelectorAll('[data-adf-size]').forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-adf-size') === idx); });
      }

      onOptionChange() {
        var sel = this.selected();
        this.options.forEach(function (fs, i) {
          var out = fs.querySelector('[data-adf-option-value="' + i + '"]');
          if (out) out.textContent = sel[i] || '';
        });
        this.syncSketch();
        var v = this.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { this.setUnavailable(); return; }
        this.variant = v;
        if (this.idInput) {
          this.idInput.value = v.id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var p = money(v.price);
        this.querySelectorAll('[data-adf-price-amount], [data-adf-atc-price]').forEach(function (el) { el.textContent = p; });
        var cmp = this.querySelector('[data-adf-price-compare]');
        if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); if (!cmp.hidden) cmp.textContent = money(v.compare_at_price); }
        var meta = this.querySelector('[data-adf-bar-meta]');
        if (meta) meta.textContent = (this.variants.length > 1 ? v.title + ' · ' : '') + p;
        var free = this.freeFrom > 0 && v.price >= this.freeFrom;
        this.querySelectorAll('[data-adf-free]').forEach(function (el) { el.hidden = !free; });
        this.querySelectorAll('[data-adf-paid]').forEach(function (el) { el.hidden = free; });
        this.setAvailable(v.available);
        if (v.featured_media) this.goTo(String(v.featured_media.id));
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      setAvailable(ok, why) {
        if (!this.submit) return;
        this.submit.disabled = !ok;
        var label = this.submit.querySelector('[data-adf-atc-label]');
        if (label) {
          if (!label.dataset.adfDefault) label.dataset.adfDefault = label.textContent;
          label.textContent = ok ? label.dataset.adfDefault : (why || 'Victime de son succès');
        }
        var bar = this.querySelector('[data-adf-bar-add]');
        if (bar) bar.disabled = !ok;
      }

      setUnavailable() { this.setAvailable(false, 'Indisponible'); }

      /* Galerie : défilement horizontal + vignettes */
      initGallery() {
        this.slides = this.querySelector('[data-adf-slides]');
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-adf-thumb]'));
        if (!this.slides || !this.thumbs.length) return;
        this.thumbs.forEach((b) => b.addEventListener('click', () => this.goTo(b.getAttribute('data-adf-thumb'))));
        var t;
        this.slides.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            var i = Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth));
            this.thumbs.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
          }, 60);
        }, { passive: true });
      }

      goTo(mediaId) {
        if (!this.slides) return;
        var li = this.slides.querySelector('[data-media-id="' + mediaId + '"]');
        if (!li) return;
        this.slides.scrollTo({ left: li.offsetLeft - this.slides.offsetLeft, behavior: SMOOTH() });
      }

      /* Zoom */
      initZoom() {
        var dlg = this.querySelector('[data-adf-zoom-dialog]');
        if (!dlg || typeof dlg.showModal !== 'function') return;
        var box = dlg.querySelector('[data-adf-zoom-box]');
        var img = document.createElement('img');
        img.decoding = 'async';
        box.appendChild(img);
        var open = () => {
          var i = this.slides ? Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth)) : 0;
          var cur = this.querySelectorAll('.adf-pdp__slide img')[i];
          if (!cur) return;
          img.src = cur.getAttribute('data-zoom') || cur.currentSrc || cur.src;
          img.alt = cur.alt;
          if (cur.naturalWidth) { img.width = cur.naturalWidth; img.height = cur.naturalHeight; }
          dlg.showModal();
          document.documentElement.classList.add('adf-no-scroll');
        };
        var btn = this.querySelector('[data-adf-zoom]');
        if (btn) btn.addEventListener('click', open);
        this.querySelectorAll('.adf-pdp__slide img').forEach(function (im) { im.addEventListener('click', open); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-adf-zoom-close]') || e.target === img) dlg.close(); });
        dlg.addEventListener('close', function () { document.documentElement.classList.remove('adf-no-scroll'); });
      }

      /* Barre d'achat collante (mobile) : apparaît quand le bouton principal est passé */
      initBar() {
        var bar = this.querySelector('[data-adf-bar]');
        if (!bar || !this.submit) return;
        var footer = document.querySelector('.adf-footer') || document.querySelector('footer');
        var shown = null, ticking = false;
        var check = () => {
          ticking = false;
          // visible dès que le bouton principal a glissé sous l'en-tête collant, cachée près du pied de page
          var past = this.submit.getBoundingClientRect().bottom < 96;
          var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
          var show = past && !nearFooter;
          if (show === shown) return;
          shown = show;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
          document.documentElement.classList.toggle('adf-has-bar', show);
        };
        var onScroll = function () { if (!ticking) { ticking = true; setTimeout(check, 30); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        check();
        var add = bar.querySelector('[data-adf-bar-add]');
        if (add) add.addEventListener('click', () => {
          // v14-7 : entretien de tombe — il manque une info ? on y emmène le client
          if (this.tomb && !this.tombValid()) return;
          // Le mot sur la carte est obligatoire : s'il est vide, on y emmène directement le client
          var card = this.querySelector('.adf-pdp__apps textarea');
          if (card && !card.value.trim()) {
            card.scrollIntoView({ behavior: SMOOTH(), block: 'center' });
            setTimeout(function () { card.focus({ preventScroll: true }); }, 450);
            return;
          }
          this.submit.click();
        });
      }
    });
  }

  /* ---------- Collection : tri + texte repliable ---------- */
  function tools(scope) {
    (scope || document).querySelectorAll('[data-adf-sort]').forEach(function (sel) {
      if (sel._adf) return; sel._adf = true;
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
    (scope || document).querySelectorAll('[data-adf-clamp]').forEach(function (box) {
      if (box._adf) return; box._adf = true;
      var btn = box.querySelector('[data-adf-clamp-btn]');
      var p = box.querySelector('p');
      if (!btn || !p) return;
      if (p.scrollHeight > p.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.textContent = open ? 'Réduire' : 'Lire la suite';
      });
    });
  }

  /* ---------- « Vous aimerez aussi » ---------- */
  function recos(scope) {
    (scope || document).querySelectorAll('.adf-recos--pending[data-adf-recos]').forEach(function (sec) {
      if (sec._adf) return; sec._adf = true;
      var load = function () {
        fetch(sec.getAttribute('data-adf-recos'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-adf-recos]');
            if (!fresh || !fresh.querySelector('.adf-prod__card')) return;
            sec.innerHTML = fresh.innerHTML;
            sec.classList.remove('adf-recos--pending');
            ship(sec.parentNode);
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(sec);
      } else load();
    });
  }

  function init(scope) { ship(scope); tools(scope); recos(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.adfShip = ship;
})();
